/* Swubie shared cart module (Horizon rebuild).
   One place for: the <cart-drawer> element (sections/cart-drawer.liquid), open / close, quantity
   and remove inside the drawer, the header count (sections/cart-icon-bubble.liquid) and a small
   API for our own scripts:
     SwubieCart.add(items, opts)   items = [{ id, quantity, properties }], adds and opens the drawer
     SwubieCart.render(data)       data = a cart response that carries sections, swaps the drawer
     SwubieCart.refresh()          re-renders drawer + count from the server
     SwubieCart.open() / close()
   The section names "cart-drawer" and "cart-icon-bubble" and the .drawer__inner / .drawer__footer
   parts are kept from Olivia, so scripts written against Olivia keep working unchanged.
   Horizon's own add-to-cart (generic product and collection pages) fires "cart:update": we
   refresh and open our drawer on that too. */
(function () {
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function swap(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      ['.drawer__inner', '.drawer__footer'].forEach(function (sel) {
        var cur = document.querySelector('#CartDrawer ' + sel), next = doc.querySelector(sel);
        if (cur && next) cur.innerHTML = next.innerHTML;
      });
      var nd = doc.querySelector('cart-drawer'), d = document.querySelector('cart-drawer');
      if (nd && d) d.classList.toggle('is-empty', nd.classList.contains('is-empty'));
    }
    if (sections['cart-icon-bubble']) {
      var b = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      var bubble = document.getElementById('cart-icon-bubble');
      if (b && bubble) bubble.innerHTML = b.innerHTML;
    }
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  /* A gift line (property _gratis = the pack variant, offer test A) leaves the cart with its pack */
  function pruneGifts(cart) {
    var items = (cart && cart.items) || [];
    var orphan = items.filter(function (it) {
      var of = it.properties && it.properties._gratis;
      return of && !items.some(function (o) { return String(o.variant_id) === String(of); });
    })[0];
    if (!orphan) return;
    return post('/cart/change.js', { id: orphan.key, quantity: 0, sections: SECTIONS }).then(function (d) { swap(d.sections); });
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.addEventListener('click', function (e) {
          if (e.target.closest('[data-swb-cart-close]')) { e.preventDefault(); self.close(); return; }
          var q = e.target.closest('[data-swb-qty]');
          if (q) {
            e.preventDefault();
            var line = q.closest('[data-key]');
            if (!line || self.classList.contains('is-busy')) return;
            self.classList.add('is-busy');
            post('/cart/change.js', { id: line.getAttribute('data-key'), quantity: parseInt(q.getAttribute('data-swb-qty'), 10) || 0, sections: SECTIONS })
              .then(function (d) { swap(d.sections); return pruneGifts(d); })
              .catch(function () { SwubieCart.refresh(); })
              .then(function () { self.classList.remove('is-busy'); });
          }
        });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.classList.contains('active')) self.close(); });
      }
      open() {
        this.classList.add('active');
        this.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('swb-drawer-open');
        var p = this.querySelector('.swb-drawer__panel'); if (p) setTimeout(function () { p.focus({ preventScroll: true }); }, 50);
      }
      close() {
        this.classList.remove('active');
        this.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('swb-drawer-open');
      }
      /* Olivia compatibility: some callers pass the add response here */
      renderContents(data) { swap(data && data.sections); this.classList.remove('is-empty'); this.open(); }
    });
  }

  var SwubieCart = {
    sections: SECTIONS,
    render: function (data) { swap(data && data.sections); },
    open: function () { var d = document.querySelector('cart-drawer'); if (d) { d.classList.remove('is-empty'); d.open(); } else window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart'; },
    close: function () { var d = document.querySelector('cart-drawer'); if (d) d.close(); },
    refresh: function () {
      return fetch('/?sections=' + SECTIONS).then(function (r) { return r.json(); }).then(swap).catch(function () {});
    },
    add: function (items, opts) {
      opts = opts || {};
      return post('/cart/add.js', { items: items, sections: SECTIONS }).then(function (d) {
        swap(d.sections);
        if (opts.open !== false) SwubieCart.open();
        return d;
      });
    }
  };
  window.SwubieCart = SwubieCart;

  /* Header cart icon opens the drawer instead of going to /cart */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('#cart-icon-bubble');
    if (!a || !document.querySelector('cart-drawer')) return;
    e.preventDefault();
    SwubieCart.open();
  });

  /* Horizon's own product forms and quick add (generic pages). Horizon 3.x fires "cart:update"
     after the request; Horizon 4.x fires the Shopify standard event "shopify:cart:lines-update"
     before it, with a promise that settles when the cart has changed. */
  function afterHorizonAdd() {
    var onCartPage = /\/cart\/?$/.test(window.location.pathname);
    SwubieCart.refresh().then(function () { if (!onCartPage) SwubieCart.open(); });
  }
  document.addEventListener('cart:update', function (e) {
    var src = e && e.detail && e.detail.data && e.detail.data.source;
    if (src === 'swubie') return;
    afterHorizonAdd();
  });
  document.addEventListener('shopify:cart:lines-update', function (e) {
    var p = e && e.promise;
    if (p && typeof p.then === 'function') p.then(afterHorizonAdd, function () {});
    else setTimeout(afterHorizonAdd, 600);
  });
})();
